import { getCurrentEvent } from '.././components/SearchResultCard/components/DetailsCard/utls/getCurrentEvent';
export const getContentInfoLive = contentInfo => {
  const adpaterRes = contentInfo?.content_type || contentInfo?.type;
  const adapterGroupId = contentInfo?.id || contentInfo?.channel_group_id;
  const currentEvent = getCurrentEvent(adpaterRes, adapterGroupId);

  const infoGeneral = {
    description: '',
    id: '',
    imgSrc: '',
    begintime: '',
    endtime: '',
    event_alf_id: '',
    name: '',
  };
  let dataTimeBegin = '';
  let dataTimeEnd = '';
  if (adpaterRes === 'E' || adpaterRes === 'L') {
    dataTimeBegin = currentEvent?.date_begin;
    dataTimeEnd = currentEvent?.date_end;
  }
  const contentDescription =
    contentInfo?.actual_event?.description || currentEvent?.description;
  switch (adpaterRes) {
    case 'S':
      (infoGeneral.description = contentInfo?.description_large),
        (infoGeneral.id = contentInfo?.id),
        (infoGeneral.imgSrc = contentInfo?.image_small),
        (infoGeneral.begintime = contentInfo?.begintime),
        (infoGeneral.endtime = contentInfo?.endtime),
        (infoGeneral.event_alf_id = ''),
        (infoGeneral.name = contentInfo?.title);
      break;
    case 'P':
      (infoGeneral.description = contentInfo?.description_large),
        (infoGeneral.id = contentInfo?.id),
        (infoGeneral.imgSrc = contentInfo?.image_small),
        (infoGeneral.begintime = contentInfo?.begintime),
        (infoGeneral.endtime = contentInfo?.endtime),
        (infoGeneral.event_alf_id = ''),
        (infoGeneral.name = contentInfo?.title);

      break;
    case 'E':
      (infoGeneral.description = contentInfo?.description),
        (infoGeneral.id = contentInfo?.channel_group_id),
        (infoGeneral.imgSrc = contentInfo?.channel_image),
        (infoGeneral.begintime = contentInfo?.begintime),
        (infoGeneral.endtime = contentInfo?.endtime),
        (infoGeneral.event_alf_id = currentEvent?.event_alf_id),
        (infoGeneral.name = currentEvent?.name);

      break;
    case 'L':
      (infoGeneral.description = contentDescription),
        (infoGeneral.id = contentInfo?.id),
        (infoGeneral.imgSrc = contentInfo?.image_small),
        (infoGeneral.begintime = dataTimeBegin),
        (infoGeneral.endtime = dataTimeEnd),
        (infoGeneral.event_alf_id = currentEvent?.event_alf_id),
        (infoGeneral.name = currentEvent?.name);
      break;
    default:
      return infoGeneral;
  }

  return infoGeneral;
};
